module.exports = __webpack_public_path__ + "img/gafas.83f7b278.webp";